import Base from "./Base"

export default {
  httpBaseUri: "https://dev-api.operandiodev.com",
  httpServiceBaseUri: "https://dev-api.operandiodev.com/graphql",
  wsServiceBaseUri: "wss://dev-api.operandiodev.com/graphql",

  clientKiosk: false,

  showConfigInTitle: true,
  configTitle: "[DEV]",

  theme: {
    ...Base.theme,

    logoContainer: "images-dev",
  },

  uploader: {
    ...Base.uploader,

    imageViewerBaseUri: "https://dydc66wtc7q9n.cloudfront.net",
    imageViewerBucketName: "operandio-content-ap-southeast-2",
  },

  services: {
    ...Base.services,
    export: {
      ...Base.services.export,
      jobUrl: "https://lxknk3pfv9.execute-api.ap-southeast-2.amazonaws.com/prod/", // DEV account
    },
  },

  errors: {
    ...Base.errors,

    showDetail: true,
    showGraphQLErrorNotification: true,
  },
}
